import { FunnelGraphModule } from "./funnelChartModule";
import rootSaga from "./redux/sagas/funnelChart";
import reducer from "./redux/reducers/funnelChart";

export default {
  Component: FunnelGraphModule,
  moduleName: "laser",
  saga: rootSaga(),
  reducer: reducer
};
